import { isSameDay, max, min } from 'date-fns';
import type { DateRange, PropsBase } from 'react-day-picker';

const getRangeModifiers = (range: DateRange, potentialDate: Date): Partial<PropsBase['modifiers']> | undefined => {
  if (!range.from || range.to) {
    // We only apply special styling when just the "from" has been selected, not when the range is complete
    return undefined;
  }

  if (isSameDay(range.from, potentialDate)) {
    return undefined;
  }

  const start = min([range.from, potentialDate]);
  const end = max([range.from, potentialDate]);

  return {
    range_start: [start],
    range_end: [end],
    range_middle: [{ after: start, before: end }],
    selected: [start, end] // Mark both dates as "selected" for styling
  };
};

export default getRangeModifiers;
